var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 7.5C10.6637 7.5 11.2996 7.76339 11.7684 8.23223C12.2373 8.70107 12.5007 9.33696 12.5007 10C12.5007 10.663 12.2373 11.2989 11.7684 11.7678C11.2996 12.2366 10.6637 12.5 10.0007 12.5C9.33761 12.5 8.70173 12.2366 8.23288 11.7678C7.76404 11.2989 7.50065 10.663 7.50065 10C7.50065 9.33696 7.76404 8.70107 8.23288 8.23223C8.70173 7.76339 9.33761 7.5 10.0007 7.5ZM10.0007 3.75C14.1673 3.75 17.7257 6.34167 19.1673 10C17.7257 13.6583 14.1673 16.25 10.0007 16.25C5.83398 16.25 2.27565 13.6583 0.833984 10C2.27565 6.34167 5.83398 3.75 10.0007 3.75ZM2.65065 10C3.3242 11.3753 4.37007 12.534 5.66938 13.3444C6.96869 14.1548 8.46931 14.5844 10.0007 14.5844C11.532 14.5844 13.0326 14.1548 14.3319 13.3444C15.6312 12.534 16.6771 11.3753 17.3507 10C16.6771 8.62474 15.6312 7.46604 14.3319 6.65562C13.0326 5.8452 11.532 5.41557 10.0007 5.41557C8.46931 5.41557 6.96869 5.8452 5.66938 6.65562C4.37007 7.46604 3.3242 8.62474 2.65065 10Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDisabledIcon);
export default __webpack_public_path__ + "static/media/eye-disabled-icon.58f60128d9958246483897c54b024b51.svg";
export { ForwardRef as ReactComponent };